export const computeDateDiffInDays = (dateStr: string): number => {
  const dateMillis = Date.parse(dateStr);
  const currentTimeMillis = Date.parse(new Date().toString());
  return Math.trunc((currentTimeMillis - dateMillis) / 86400000);
};
